export default __webpack_public_path__ + "static/media/FDR-01.9260854c.svg";